import React, { useState, useRef, useEffect } from 'react';

const CustomDropdown = ({ children, ContentComponent, isRight, onClose = () => {} }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (!isOpen) {
      onClose();
    }
  }, [isOpen])

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} style={{ position: 'relative', display: 'inline-block' }}>
      <div onClick={handleToggle}>
        {children}
      </div>
      {isOpen && (
        <div style={isRight ? { position: 'absolute', top: '100%', right: 0, zIndex: 1 } : { position: 'absolute', top: '100%', left: 0, zIndex: 1 }} className="shadow-md rounded-lg border border-mute-200 mt-1">
          <ContentComponent />
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;